module.exports = "/shiftTasks/components/taskInstances/taskInstancesViewRow-a199e2.html";